import { IPaymentMethod } from '@checkout/state';
import { checkIfArrayOfStringsContainsElement } from './utils';

export enum KlarnaPayments {
  invoiceUri = 'klarna-invoice',
  kontoUri = 'klarna-konto'
}

export const klarnaPaymentsUriValues = [KlarnaPayments.invoiceUri, KlarnaPayments.kontoUri];

export const includesPaymentMethod = (paymentMethods: IPaymentMethod[], paymentMethod: string): boolean => {
  return paymentMethods.some((element: IPaymentMethod) => element.paymentMethod.startsWith(paymentMethod));
};

export const getMathchingPaymentMethod = (paymentMethods: IPaymentMethod[], paymentMethod: string): IPaymentMethod => {
  return paymentMethods.filter((element: IPaymentMethod) => element.paymentMethod.startsWith(paymentMethod))[0];
};

export const isKlarnaCheckout = (selectedPaymentMethod: string | undefined): boolean => {
  return selectedPaymentMethod !== undefined && selectedPaymentMethod.startsWith('klarna-checkout');
};

export const isOnlyKlarnaCheckout = (paymentMethods: IPaymentMethod[]): boolean => {
  return paymentMethods && paymentMethods.length === 1 && paymentMethods[0].paymentMethod.startsWith('klarna-checkout');
};

export const isKlarnaCheckoutAvailable = (paymentMethods: IPaymentMethod[]): boolean => {
  return paymentMethods && paymentMethods.length > 0 && includesPaymentMethod(paymentMethods, 'klarna-checkout');
};

export const isPaypalAvailable = (paymentMethods: IPaymentMethod[]): boolean => {
  return paymentMethods && paymentMethods.length > 0 && includesPaymentMethod(paymentMethods, 'paypal');
};

export const isPaypal = (selectedPaymentMethod: string | undefined): boolean => {
  return selectedPaymentMethod !== undefined && selectedPaymentMethod.startsWith('paypal');
};

// Klarna Invoice, Klarna Konto
export const isKlarnaPayments = (paymentMethods: IPaymentMethod[]): boolean => {
  return paymentMethods && paymentMethods.some((paymentMethod: IPaymentMethod) =>
      !!(paymentMethod.clientSide && checkIfArrayOfStringsContainsElement(klarnaPaymentsUriValues, paymentMethod.paymentMethod)));
};
